import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import useRemoteConfig from '../useRemoteConfig';

import { isRemoteConfigOrgAllowed } from './remoteConfigAccess';
import { REMOTE_CONFIG_POLICIES, type RemoteConfigKey } from './remoteConfigKeys';

type UseRemoteConfigAccessResult = {
  isAllowed: boolean;
  isLoaded: boolean;
  loading: boolean;
  value: unknown;
};

export const useRemoteConfigAccess = (key: RemoteConfigKey): UseRemoteConfigAccessResult => {
  const orgId = useSelector(
    ({ organizations }: { organizations: { organization: { id: string } } }) =>
      organizations.organization.id,
  );
  const { value, isLoaded, loading } = useRemoteConfig(key);
  const policy = REMOTE_CONFIG_POLICIES[key];

  const isAllowed = useMemo(() => {
    if (!isLoaded) return false;
    return isRemoteConfigOrgAllowed(value, orgId, policy);
  }, [isLoaded, orgId, policy, value]);

  return {
    isAllowed,
    isLoaded,
    loading,
    value,
  };
};
